import {
  ANTHROPIC_FABLE_5_1_MODEL_REF,
  ANTHROPIC_FABLE_5_MODEL_REF,
} from "./anthropic";
import {
  DEEPSEEK_V4_PRO_AZURE_MODEL_REF,
  KIMI_K26_AZURE_MODEL_REF,
} from "./azureFoundry";
import {
  BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_REF,
  BEDROCK_ANTHROPIC_FABLE_5_MODEL_REF,
} from "./bedrockAnthropic";
import {
  BEDROCK_OPENAI_GPT_5_4_MODEL_REF,
  BEDROCK_OPENAI_GPT_5_5_MODEL_REF,
  BEDROCK_OPENAI_GPT_5_6_SOL_MODEL_REF,
} from "./bedrockOpenAi";
import { BEDROCK_CONVERSE_FABLE_5_1_MODEL_REF } from "./claudeFable";
import { BEDROCK_CONVERSE_OPUS_5_5_MODEL_REF } from "./claudeOpus";
import { GLM_52_FAST_MODEL_REF, GLM_52_MODEL_REF } from "./glmOpenRouter";
import { GROK_45_MODEL_REF } from "./grokOpenRouter";
import { KIMI_K3_MODEL_REF } from "./kimiK3OpenRouter";
import {
  OPENAI_GPT_5_6_SOL_MODEL_REF,
  OPENAI_GPT_6_ASTRA_MODEL_REF,
  OPENAI_GPT_6_SOL_MODEL_REF,
} from "./openAi";

export interface SelectableActorModel {
  /** Model ref as stored on templates / instances. */
  ref: string;
  /** Human-readable label for the selector. */
  label: string;
}

export const SELECTABLE_ACTOR_MODELS: readonly SelectableActorModel[] = [
  { label: "GPT-5.6 Sol (OpenAI)", ref: OPENAI_GPT_5_6_SOL_MODEL_REF },
  { label: "GPT-6 Astra (OpenAI)", ref: OPENAI_GPT_6_ASTRA_MODEL_REF },
  { label: "GPT-6 Sol (OpenAI)", ref: OPENAI_GPT_6_SOL_MODEL_REF },
  { label: "GPT-5.6 Sol (Bedrock)", ref: BEDROCK_OPENAI_GPT_5_6_SOL_MODEL_REF },
  { label: "GPT-5.5 (Bedrock)", ref: BEDROCK_OPENAI_GPT_5_5_MODEL_REF },
  // First-party OpenAI route for GPT-5.5 (provider "openai", model id "gpt-5.5"),
  // AWS-independent — resilient to Bedrock-mantle outages that take down the
  // bedrock-openai route above. Requires the org to have an OpenAI API key
  // (orgApiKeys.openAiApiKey); otherwise selecting it fails with a 401 at wake.
  { label: "GPT-5.5 (OpenAI)", ref: "openai/gpt-5.5" },
  { label: "GPT-5.4 (Bedrock)", ref: BEDROCK_OPENAI_GPT_5_4_MODEL_REF },
  { label: "Kimi K2.6 (Azure)", ref: KIMI_K26_AZURE_MODEL_REF },
  { label: "Kimi K3", ref: KIMI_K3_MODEL_REF },
  { label: "DeepSeek V4 Pro (Azure)", ref: DEEPSEEK_V4_PRO_AZURE_MODEL_REF },
  { label: "DeepSeek V4 Pro", ref: "openrouter/deepseek/deepseek-v4-pro" },
  { label: "MiMo V2.5 Pro", ref: "openrouter/xiaomi/mimo-v2.5-pro" },
  { label: "MiniMax M3", ref: "openrouter/minimax/minimax-m3" },
  { label: "GLM 5.2", ref: GLM_52_MODEL_REF },
  { label: "GLM 5.2 Fast", ref: GLM_52_FAST_MODEL_REF },
  { label: "Grok 4.5", ref: GROK_45_MODEL_REF },
  { label: "Gemini 3.5 Flash", ref: "google/gemini-3.5-flash" },
  { label: "Claude Fable 5.1", ref: BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_REF },
  { label: "Claude Fable 5.1 (Anthropic)", ref: ANTHROPIC_FABLE_5_1_MODEL_REF },
  {
    label: "Claude Fable 5.1 (Converse)",
    ref: BEDROCK_CONVERSE_FABLE_5_1_MODEL_REF,
  },
  { label: "Claude Fable 5", ref: BEDROCK_ANTHROPIC_FABLE_5_MODEL_REF },
  { label: "Claude Fable 5 (Anthropic)", ref: ANTHROPIC_FABLE_5_MODEL_REF },
  {
    label: "Claude Fable 5 (Converse)",
    ref: "bedrock/global.anthropic.claude-fable-5",
  },
  { label: "Opus 5.5", ref: BEDROCK_CONVERSE_OPUS_5_5_MODEL_REF },
  { label: "Opus 5", ref: "bedrock/global.anthropic.claude-opus-5" },
  { label: "Sonnet 5", ref: "bedrock/global.anthropic.claude-sonnet-5" },
  { label: "Sonnet 4.6", ref: "bedrock/global.anthropic.claude-sonnet-4-6" },
  { label: "Opus 4.6", ref: "bedrock/global.anthropic.claude-opus-4-6-v1" },
  { label: "Opus 4.7", ref: "bedrock/global.anthropic.claude-opus-4-7" },
  { label: "Opus 4.8", ref: "bedrock/global.anthropic.claude-opus-4-8" },
  { label: "Opus 4.8", ref: "anthropic/claude-opus-4-8" },
];
